import { fullWindowHeightMixinBlock } from '../../mixins/fullWindowHeightMixinBlock/fullWindowHeightMixinBlock';

const NS = 'CampaignHeroBlock';
const CLS = 'campaignHeroBlock';

import { scrollIntoView } from 'scroll-js';

export class CampaignHeroBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$tplScroller = $('.tpl-scroller');
		this.$tplHeader = $('.tpl-header');
		this.$tplHeader.addClass('tpl-header--fixed');
		this.$siteHeader = this.$tplHeader.find('.siteHeaderWidget');

		this.$scrollToButton = this.$element.find(`.${CLS}-scrollTo`);
		this.$scrollToButton.on('click', () => {
			scrollIntoView(this.$element.next(`[class*='Block']`)[0], $('.tpl-scroller')[0], { duration: 750, easing: 'ease-in-out' });
		});

		this.initFullWindowHeight(this);
		this.$tplScroller.on('scroll', _.throttle(() => {
			this.siteHeaderWidgetColorChange();
		}, 250));
	}

	siteHeaderWidgetColorChange() {
		if(Math.ceil((this.$element.position().top + this.$element.outerHeight())) - this.$siteHeader.height() <= 0) {
			this.$siteHeader.css({
				backgroundColor: 'rgba(0, 0, 0, .4)',
				transition: 'background-color 0.4s ease-in-out'
			});
		}
		else {
			this.$siteHeader.css({
				backgroundColor: 'transparent'
			});
		}
	}
}

Object.assign(CampaignHeroBlock.prototype, fullWindowHeightMixinBlock);
